export const EnPath = {
  programs:'/en/programs',
  hotels:'/en/hotels',
  search:'/en/search',
  restaurants:'/en/restaurants',
  shopping:'/en/shopping',
  transportation:'/en/transportation',
  places:'/en/places',
  partners:'/en/partners',
  blog:'/en/blog',
  posts:'/en/blog/*',
  singleProg:'/en/programs/*'
}

export const ArPath = {
  programs:'/ar/البرامج',
  hotels:'/ar/الفنادق',
  search:'/ar/البحث',
  restaurants:'/ar/المطاعم',
  shopping:'/ar/التسوق',
  transportation:'/ar/النقل',
  places:'/ar/المزارات',
  partners:'/ar/شركاؤنا',
  blog:'/ar/المواضيع',
  posts:'/ar/المواضيع/*',
  singleProg:'/ar/البرامج/*'
}
